import * as moment from 'moment';
import {FinzyFee} from './FinzyFee';

export class Emi {
    public _id: string;
    public due_on: Date;
    public balance_amount: number;
    public emi_amount: number;
    public status: string;
    public principal_repayment: number;
    public interest_payable: number;
    private payment_through: string;
    public emi_after_delay: number;
    public finzyFee: FinzyFee;
    private description: string;
    public penalInterest: number;
    public subvention: {
        principal_repayment: number;
        interest_payable: number;
        balance_amount: number;
        emi_amount: number;
        subvention_amount: number;
        remaining_subvention_amount: number;
    };
    public remaining_tenure: number;
    public paid_on: Date;

    constructor();
    constructor(due_on: Date, balance_amount: number, emi_amount: number, status: string, principal_repayment: number, interest_payable: number, payment_through?: string, description?: string, penalInterest?: number);
    constructor(due_on?: Date, balance_amount?: number, emi_amount?: number, status?: string, principal_repayment?: number, interest_payable?: number, payment_through?: string, description?: string, penalInterest?: number) {
        this.due_on = due_on;
        this.balance_amount = balance_amount;
        this.emi_amount = emi_amount;
        this.payment_through = payment_through;
        this.status = status;
        this.principal_repayment = principal_repayment;
        this.interest_payable = interest_payable;
        this.description = description;
        this.penalInterest = penalInterest;
    }

    public static from(json: any): Emi {
        const emi = new Emi();
        Object.assign(emi, json);
        if (json.finzyFee) {
            emi.finzyFee = FinzyFee.from(json.finzyFee);
        }
        this.assignDateIfItExists(json, emi, 'due_on');
        this.assignDateIfItExists(json, emi, 'paid_on');
        this.assignDateIfItExists(json, emi, 'presented_on');
        return emi;
    }

    private static assignDateIfItExists(json: any, emi: Emi, field: string): void {
        if (json[field]) {
            emi[field] = moment(json[field]).toDate();
        }
    }
}

export class EmiSchedule extends Array<Emi> {
}
